(ns io.daskul.tutorial.webapp.effects
  "Product-specific re-frame effects.

   :notification    - Show toast notification via Mantine
   :sentry/set-user - Set Sentry user context (from JWT claims)
   :sentry/clear-user - Clear Sentry user context

   Note: :localstorage/* effects are registered by webapp-ui lib
   (io.daskul.webapp.effects.core)."
  (:require
   [re-frame.core :as rf]
   ["@mantine/notifications" :refer [notifications]]
   [io.daskul.tutorial.webapp.shared.sentry :as sentry]))

(rf/reg-fx
 :notification
 (fn [{:keys [title message color]}]
   (let [is-error? (= color "red")]
     (.show notifications (clj->js {:title title
                                     :message message
                                     :color (or color "blue")
                                     :autoClose (if is-error? false 4000)})))))

(rf/reg-fx
 :sentry/set-user
 (fn [user]
   (sentry/set-user! user)))

(rf/reg-fx
 :sentry/clear-user
 (fn [_]
   (sentry/clear-user!)))

(rf/reg-fx
 :clarity/identify
 (fn [{:keys [id role school-id branch-id impersonator]}]
   (when (exists? js/window.clarity)
     (js/window.clarity "identify" (str id))
     (js/window.clarity "set" "role" (str role))
     (js/window.clarity "set" "school-id" (str school-id))
     (when branch-id
       (js/window.clarity "set" "branch-id" (str branch-id)))
     (when impersonator
       (js/window.clarity "set" "impersonated" "true")))))

(rf/reg-fx
 :clarity/clear
 (fn [_]
   (when (exists? js/window.clarity)
     (js/window.clarity "identify" nil))))
